import { VdsCard, VdsIcon } from '@volt/volt-extended-components-react';
import styles from './SettingsSummaryCard.module.scss';
import { ReactElement, useCallback } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useAppDispatch } from '@casops/store/hooks';
import { openSidePanel, SettingsSidePanelTab, SidePanel } from '@casops/store/slices/globalSlice';

export type SettingDetail = [string, string | undefined];

interface SettingsSummaryCardProps {
  title: string;
  settings: SettingDetail[];
  sidePanelTab: SettingsSidePanelTab;
}

export const SettingsSummaryCard = ({
  title,
  settings,
  sidePanelTab,
}: SettingsSummaryCardProps): ReactElement => {
  const dispatch = useAppDispatch();

  const onOpenSettings = useCallback(() => {
    dispatch(
      openSidePanel({
        sidePanel: SidePanel.Settings,
        tab: sidePanelTab,
        editMode: true,
      }),
    );
  }, [dispatch, sidePanelTab]);

  return (
    <VdsCard className={styles.card} padding="spacing-05" button onClick={onOpenSettings}>
      <article className={styles.container}>
        <header className={styles.header}>
          <div className={styles.title}>{title}</div>
          <VdsIcon svgIcon="edit" size="22px" color="color-icon-medium" />
        </header>
        <div className={styles.content}>
          {settings.map(([label, value]: SettingDetail, index) => (
            <div key={index} className={styles.setting}>
              <div className={styles.setting__label}>{label}</div>
              {typeof value === 'undefined' ? (
                <Skeleton width={'50%'} height={18} />
              ) : (
                <div className={styles.setting__value}>{value}</div>
              )}
            </div>
          ))}
        </div>
      </article>
    </VdsCard>
  );
};

export default SettingsSummaryCard;
